var _stop, _stop2, _stop3, _stop4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";

function SvgStoryIcon(props) {
  var _id2 = useUniqueInlineId();

  var _id = useUniqueInlineId();

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.632 40H2.098C.941 40 0 39.03 0 37.838V2.162C0 .97.941 0 2.098 0h21.534c1.157 0 2.098.97 2.098 2.162v35.676c0 1.192-.94 2.162-2.098 2.162zm-.408-38.198H2.507c-.612 0-1.108.496-1.108 1.108v34.54c0 .612.496 1.109 1.108 1.109h20.717c.612 0 1.108-.497 1.108-1.109V2.91c0-.612-.496-1.108-1.108-1.108zM12.865 34.234c-.386 0-.7.324-.7.721 0 .397.314.72.7.72.386 0 .7-.323.7-.72a.711.711 0 00-.7-.72zM11.466 2.883h2.798c.387 0 .7.323.7.72a.71.71 0 01-.7.721h-2.798a.71.71 0 01-.699-.72.71.71 0 01.7-.721z",
    fill: "url(#".concat(_id, ")"),
    transform: "translate(6.825)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84 12.39c-.555.33-.894.945-.894 1.61v11.002c0 .665.34 1.28.896 1.61a1.69 1.69 0 001.807-.05l8.24-5.501c.51-.342.815-.93.815-1.56s-.306-1.22-.815-1.56l-8.237-5.5a1.683 1.683 0 00-1.813-.051zm1.011 1.302l8.242 5.503a.367.367 0 01.152.306c0 .128-.06.244-.153.306l-8.239 5.5a.26.26 0 01-.282.008.361.361 0 01-.166-.313V13.999c0-.135.066-.255.167-.315a.256.256 0 01.28.008z",
    fill: "url(#".concat(_id2, ")"),
    transform: "translate(6.825)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.584%",
    y1: "7.565%",
    x2: "38.662%",
    y2: "87.141%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC54BE",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5802D5",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "64.818%",
    y1: "7.565%",
    x2: "32.471%",
    y2: "87.141%",
    id: _id2
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC54BE",
    offset: "0%"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5802D5",
    offset: "100%"
  })))));
}

export default SvgStoryIcon;